import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import login_en from './locales/en/login.json'
import vitals_en from './locales/en/vitals.json'
import fullChart_en from './locales/en/fullChart.json'
import timeline_en from './locales/en/timeline.json'
import common_en from './locales/en/common.json'
import shift_en from './locales/en/shift.json'
import login_gb from './locales/gb/login.json'
import home_en from './locales/en/home.json'
import vitals_gb from './locales/gb/vitals.json'
import timeline_gb from './locales/gb/timeline.json'
import common_gb from './locales/gb/common.json'
import serviceSelection_en from './locales/en/serviceSelection.json'
import serviceSelection_gb from './locales/gb/serviceSelection.json'
import times_en from './locales/en/times.json'
import patientDemographics_en from './locales/en/patientDemographics.json'
import authorizationInformation_en from './locales/en/authorizationInformation.json'
import driversLicenseScanner_en from './locales/en/driversLicenseScanner.json'
import documentScanner_en from './locales/en/documentScanner.json'
import ekgImport_en from './locales/en/ekgImport.json'
import patientAllergies_en from './locales/en/patientAllergies.json'
import patientMedicalHistory_en from './locales/en/patientMedicalHistory.json'
import patientMedications_en from './locales/en/patientMedications.json'
import addMedicationAdministered_en from './locales/en/addMedicationAdministered.json'
import attachments_en from './locales/en/attachments.json'
import quickActions_en from './locales/en/quickActions.json'
import intubation_en from './locales/en/intubation.json'
import procedure_en from './locales/en/procedure.json'
import tripInformation_en from './locales/en/tripInformation.json'
import pickupAddress_en from './locales/en/pickupAddress.json'
import destinationAddress_en from './locales/en/destinationAddress.json'
import airway_en from './locales/en/airway.json'
import childbirthOB_en from './locales/en/childbirthOB.json'
import imagingUltrasound_en from './locales/en/imagingUltrasound.json'
import initiateIv_en from './locales/en/initiateIv.json'
import immobilization_en from './locales/en/immobilization.json'
import medicalConsult_en from './locales/en/medicalConsult.json'
import extrication_en from './locales/en/extrication.json'
import operations_en from './locales/en/operations.json'
import rescue_en from './locales/en/rescue.json'
import ventilator_en from './locales/en/ventilator.json'
import criticalCare_en from './locales/en/criticalCare.json'
import hospitalNotify_en from './locales/en/hospitalNotify.json'
import woundCare_en from './locales/en/woundCare.json'
import share_en from './locales/en/share.json'
import completeChart_en from './locales/en/completeChart.json'
import signatures_en from './locales/en/signatures.json'
import narrative_en from './locales/en/narrative.json'
import cadImport_en from './locales/en/cadImport.json'
import ccHpi_en from './locales/en/ccHpi.json'
import insuranceInformation_en from './locales/en/insuranceInformation.json'
import relationshipsAndGuarantors_en from './locales/en/relationshipsAndGuarantors.json'
import pcsInformation_en from './locales/en/pcsInformation.json'
import cmsInformation_en from './locales/en/cmsInformation.json'
import paymentInformation_en from './locales/en/paymentInformation.json'
import landing_en from './locales/en/landing.json'
import patientSearch_en from './locales/en/patientSearch.json'
import cameraAttachments_en from './locales/en/cameraAttachments.json'
import factorsAffectingCare_en from './locales/en/factorsAffectingCare.json'
import sceneDescription_en from './locales/en/sceneDescription.json'
import exposure_en from './locales/en/exposure.json'
import zollSupportTicket_en from './locales/en/zollSupportTicket.json'
import neuro_en from './locales/en/neuro.json'
import initialAssessmentAirway_en from './locales/en/initialAssessmentAirway.json'
import respiratory_en from './locales/en/respiratory.json'
import cardio_en from './locales/en/cardio.json'
import notifications_en from './locales/en/notifications.json'
import drain_en from './locales/en/drain.json'
import titrate_en from './locales/en/titrate.json'
import labs_en from './locales/en/labs.json'
import pnProcedure_en from './locales/en/pnProcedure.json'
import pnMedication_en from './locales/en/pnMedication.json'
import immunization_en from './locales/en/immunization.json'
import rules_en from './locales/en/rules.json'
import diagnosis_en from './locales/en/diagnosis.json'
import additionalAssessments_en from './locales/en/additionalAssessments.json'
import fluids_en from './locales/en/fluids.json'
import bodyAssessment_en from './locales/en/bodyAssessment.json'
import drainsAndTubes_en from './locales/en/drainsAndTubes.json'
import burns_en from './locales/en/burns.json'
import pnnv_en from './locales/en/pnnv.json'
import customStateElement_en from './locales/en/customStateElement.json'
import bloodProductAdministration_en from './locales/en/bloodProductAdministration.json'
import ventricularAssistDevice_en from './locales/en/ventricularAssistDevice.json'
import assessment_en from './locales/en/assessmentProcedure.json'
import messages_en from './locales/en/messages.json'
import specialReports_en from './locales/en/specialReports.json'
import fillablePDFs_en from './locales/en/fillablePDFs.json'
import sessionResume_en from './locales/en/sessionResume.json'
import pulsara_en from './locales/en/pulsara.json'
import qaFlags_en from './locales/en/qaFlags.json'

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          common: common_en,
          vitals: vitals_en,
          timeline: timeline_en,
          serviceSelection: serviceSelection_en,
          shift: shift_en,
          login: login_en,
          home: home_en,
          times: times_en,
          fullChart: fullChart_en,
          patientDemographics: patientDemographics_en,
          dl: driversLicenseScanner_en,
          documentScanner: documentScanner_en,
          ekg: ekgImport_en,
          patientAllergies: patientAllergies_en,
          patientMedicalHistory: patientMedicalHistory_en,
          patientMedications: patientMedications_en,
          addMedicationAdministered: addMedicationAdministered_en,
          attachments: attachments_en,
          quickActions: quickActions_en,
          intubation: intubation_en,
          procedure: procedure_en,
          tripInformation: tripInformation_en,
          pickupAddress: pickupAddress_en,
          destinationAddress: destinationAddress_en,
          airway: airway_en,
          childbirthOB: childbirthOB_en,
          imagingUltrasound: imagingUltrasound_en,
          initiateIv: initiateIv_en,
          immobilization: immobilization_en,
          medicalConsult: medicalConsult_en,
          extrication: extrication_en,
          operations: operations_en,
          rescue: rescue_en,
          ventilator: ventilator_en,
          criticalCare: criticalCare_en,
          hospitalNotify: hospitalNotify_en,
          woundCare: woundCare_en,
          share: share_en,
          completeChart: completeChart_en,
          signature: signatures_en,
          narrative: narrative_en,
          cadImport: cadImport_en,
          ccHpi: ccHpi_en,
          insuranceInformation: insuranceInformation_en,
          relationshipsAndGuarantors: relationshipsAndGuarantors_en,
          pcsInformation: pcsInformation_en,
          authorizationInformation: authorizationInformation_en,
          cmsInformation: cmsInformation_en,
          paymentInformation: paymentInformation_en,
          landingPage: landing_en,
          patientSearch: patientSearch_en,
          cameraAttachments: cameraAttachments_en,
          factorsAffectingCare: factorsAffectingCare_en,
          sceneDescription: sceneDescription_en,
          exposure: exposure_en,
          zollSupportTicket: zollSupportTicket_en,
          neuro: neuro_en,
          initialAssessmentAirway: initialAssessmentAirway_en,
          respiratory: respiratory_en,
          cardio: cardio_en,
          notifications: notifications_en,
          drain: drain_en,
          titrate: titrate_en,
          labs: labs_en,
          pnProcedure: pnProcedure_en,
          pnMedication: pnMedication_en,
          immunization: immunization_en,
          rules: rules_en,
          diagnosis: diagnosis_en,
          additionalAssessments: additionalAssessments_en,
          fluids: fluids_en,
          bodyAssessment: bodyAssessment_en,
          drainsAndTubes: drainsAndTubes_en,
          burns: burns_en,
          pnnv: pnnv_en,
          customStateElement: customStateElement_en,
          bloodProductAdministration: bloodProductAdministration_en,
          ventricularAssistDevice: ventricularAssistDevice_en,
          assessment: assessment_en,
          messages: messages_en,
          specialReports: specialReports_en,
          fillablePDFs: fillablePDFs_en,
          sessionResume: sessionResume_en,
          pulsara: pulsara_en,
          qaFlags: qaFlags_en,
        },
      },
      gb: {
        translation: {
          common: common_gb,
          vitals: vitals_gb,
          timeline: timeline_gb,
          serviceSelection: serviceSelection_gb,
          login: login_gb,
        },
      },
    },
  })

export default i18n
